const steps = [
  {
    number: '01',
    icon: 'ri-compass-discover-line',
    badge: 'Research AI',
    title: 'Маркетинговая архитектура',
    intro: 'Начинаем не с постов, а с цифр и психологии.',
    what: 'Проектируем Карту продукта и персонажей. Определяем Jobs to Be Done (зачем у вас покупают) и путь клиента (CJM).',
    ai: 'Агент-аналитик мгновенно обрабатывает тысячи постов конкурентов, выявляя самые виральные темы и «боли» аудитории.',
    deliverable: 'Карта продукта, анализ выгод, конкурентная разведка в SMM.',
    color: 'bg-[#1A2B4C]',
  },
  {
    number: '02',
    icon: 'ri-route-line',
    badge: 'Planning AI',
    title: 'Контент-стратегия и прогрев',
    intro: 'Создаём «скользкую дорожку», по которой читатель доходит до покупки.',
    what: 'Создаём рубрикатор и воронки контента по Лестнице Ханта. Работаем с репутацией и отзывами.',
    ai: 'Агент-стратег генерирует 50+ идей для постов и сценариев Reels на основе мировых трендов, адаптируя их под ваш Tone of Voice.',
    deliverable: 'Контент-план на 14 дней, стратегия создания бренда-комьюнити.',
    color: 'bg-[#253D6B]',
  },
  {
    number: '03',
    icon: 'ri-video-add-line',
    badge: 'Content AI',
    title: 'Производство контента будущего',
    intro: 'Создаём контент, который выделяется в ленте и удерживает внимание.',
    what: 'Пишем тексты, создаём сторис, монтируем вертикальные видео (Reels, Clips, Shorts) для алгоритмического продвижения.',
    ai: 'Агент-копирайтер готовит черновики по формулам AIDA/PAS, а дизайнерские нейросети создают уникальный визуал. Мы «очеловечиваем» каждый результат.',
    deliverable: '25 публикаций «под ключ» (текст + визуал + видео).',
    color: 'bg-[#1A2B4C]',
  },
  {
    number: '04',
    icon: 'ri-team-line',
    badge: 'Engagement AI',
    title: 'Комьюнити-менеджмент и вовлечение',
    intro: 'Превращаем охваты в лояльных последователей.',
    what: 'Запускаем конкурсы, работаем с комментариями и создаём среду для общения адвокатов бренда.',
    ai: 'Агенты-модераторы помогают мгновенно реагировать на вопросы в Директе, чтобы вы не теряли клиентов из-за долгого ожидания.',
    deliverable: 'Активная аудитория, рост вовлечённости и лояльности.',
    color: 'bg-[#253D6B]',
  },
  {
    number: '05',
    icon: 'ri-line-chart-line',
    badge: 'Analytic AI',
    title: 'Аналитика и масштабирование',
    intro: 'Управляем маркетингом на основе твёрдых данных.',
    what: 'Еженедельный разбор эффективности и корректировка стратегии для снижения стоимости лида.',
    ai: 'Агент-аналитик строит автоматические дашборды, отслеживает ROI и выявляет точки роста — масштабируем то, что работает.',
    deliverable: 'Единый аналитический дашборд и понятные отчёты о прибыли.',
    color: 'bg-[#1A2B4C]',
  },
];

export default function SMMProcess() {
  return (
    <section id="smm-process" className="py-12 sm:py-24 bg-[#F9F5EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-robot-2-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Тандем интеллекта и нейросетей
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Как мы строим вашу систему
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto mb-5 rounded-full"></div>
          <p className="text-sm sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
            Мы внедрили ИИ-агентов в каждый этап работы. Это позволяет нам проводить глубочайший анализ
            за часы и создавать в 5 раз больше качественного контента, не теряя в смыслах.
          </p>
        </div>

        <div className="space-y-3 sm:space-y-5">
          {steps.map((step) => (
            <div key={step.number} className={`${step.color} rounded-2xl sm:rounded-3xl overflow-hidden`}>
              <div className="p-4 sm:p-8">
                {/* Mobile header */}
                <div className="flex items-center gap-3 mb-3 sm:hidden">
                  <div className="w-10 h-10 rounded-xl bg-[#C5A880]/20 border border-[#C5A880]/30 flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-lg text-[#C5A880]`}></i>
                  </div>
                  <div>
                    <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] uppercase tracking-wider block">
                      Шаг {step.number} — {step.badge}
                    </span>
                    <h3 className="text-sm font-bold text-white font-['Playfair_Display'] mt-0.5 leading-snug">
                      {step.title}
                    </h3>
                  </div>
                </div>

                {/* Desktop layout */}
                <div className="hidden sm:flex items-start gap-6">
                  <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-[#C5A880]/20 border border-[#C5A880]/30 flex items-center justify-center">
                    <i className={`${step.icon} text-2xl text-[#C5A880]`}></i>
                  </div>
                  <div className="flex-shrink-0 w-56">
                    <span className="inline-block px-3 py-1 rounded-full bg-[#C5A880]/20 border border-[#C5A880]/30 text-[#C5A880] text-xs font-semibold font-['Montserrat'] mb-2">
                      Шаг {step.number} — {step.badge}
                    </span>
                    <h3 className="text-base font-bold text-white font-['Playfair_Display'] leading-snug">
                      {step.title}
                    </h3>
                    <p className="text-white/50 text-xs font-['Montserrat'] mt-1 italic leading-relaxed">
                      {step.intro}
                    </p>
                  </div>
                  <div className="hidden sm:block w-px h-16 bg-white/15 flex-shrink-0 mt-1"></div>
                  <div className="flex-1 space-y-2">
                    <div className="flex items-start gap-2">
                      <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] whitespace-nowrap mt-0.5">Что делаем:</span>
                      <p className="text-white/75 text-xs sm:text-sm leading-relaxed font-['Montserrat'] text-justify">{step.what}</p>
                    </div>
                    <div className="flex items-start gap-2">
                      <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] whitespace-nowrap mt-0.5">Роль ИИ:</span>
                      <p className="text-white/75 text-xs sm:text-sm leading-relaxed font-['Montserrat'] text-justify">{step.ai}</p>
                    </div>
                    <div className="flex items-start gap-2 border-t border-white/10 pt-2">
                      <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] whitespace-nowrap mt-0.5">Результат:</span>
                      <p className="text-white/60 text-xs leading-relaxed font-['Montserrat'] italic">{step.deliverable}</p>
                    </div>
                  </div>
                </div>

                {/* Mobile content */}
                <div className="sm:hidden space-y-2">
                  <div>
                    <p className="text-white/50 text-xs font-['Montserrat'] italic mb-2">{step.intro}</p>
                  </div>
                  <div>
                    <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] block mb-1">Что делаем:</span>
                    <p className="text-white/75 text-xs leading-relaxed font-['Montserrat'] text-justify">{step.what}</p>
                  </div>
                  <div>
                    <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] block mb-1">Роль ИИ:</span>
                    <p className="text-white/75 text-xs leading-relaxed font-['Montserrat'] text-justify">{step.ai}</p>
                  </div>
                  <div className="border-t border-white/10 pt-2">
                    <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] block mb-1">Результат:</span>
                    <p className="text-white/60 text-xs leading-relaxed font-['Montserrat'] italic">{step.deliverable}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
